<template>
  <el-dialog :title="initData.topicId ? $t('COMMON_EDIT') : $t('PAGE_PBC_ADD_TOP')"
             visible
             width="60%"
             @close="onCancel">

    <el-form :model="ruleForm"
             :rules="rules"
             ref="ruleForm"
             label-width="180px"
             class="demo-ruleForm">
      <el-form-item :label="$t('TABLE_HEADER_topicName')"
                    prop="name">

        <el-input v-model="ruleForm.name"
                  maxlength="100"></el-input>
      </el-form-item>
      <el-form-item :label="$t('PAFE_PBC_LIST_DESC')"
                    prop="description">

        <el-input type='textarea'
                  maxlength="250"
                  show-word-limit
                  :rows="4"
                  class="text-area-cls"
                  v-model="ruleForm.description"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="onCancel"
                 class="wl-grey">{{$t('comment_reSet')}}</el-button>
      <el-button
              type="primary"
              @click="onConfirm"
              class="wl-green">{{ initData.topicId ? $t('btn_confirm') : $t('COMMON_ADD')}}</el-button>

    </span>
  </el-dialog>
</template>
<script>
import { UserInput } from '@/utils'

export default {
    data() {
        return {
            ruleForm: {
                name: '',
                description: '',
                topicBindId: '',
                topicId: ''
            }
        }
    },
    computed: {
        rules() {
            const rules = {
                name: [
                    { required: true, message: this.$t('FORM_VALIDATE_REQUIRED'), trigger: 'blur' },
                    {
                        pattern: UserInput.reg3,
                        trigger: 'blur',
                        message: this.$t('ILLEGAL_USER_INPUT_04')
                    }
                ],
                description: []
            }
            return rules
        }
    },
    methods: {
        onConfirm() {
            this.$refs.ruleForm.validate(validate => {
                if (validate) {
                  if(this.initData.topicId){
                    this.onEdit(this.ruleForm)
                  } else {
                    this.onAdd(this.ruleForm)
                  }
                }
            })
        }
    },
    mounted() {
      if(this.initData.topicId){
        this.ruleForm.name = this.initData.topicName
        this.ruleForm.description = this.initData.topicDesc
        this.ruleForm.topicBindId = this.initData.topicBindId
        this.ruleForm.topicId = this.initData.topicId
      }
    },
    props: {
      initData: Object,
        onAdd: Function,
        onEdit: Function,
        onCancel: Function
    }
}
</script>
<style scoped>
.wl-m-select {
    width: 100%;
}
::v-deep .text-area-cls .el-textarea__inner{
  border-width: 1PX;
}
</style>
